import { render } from "./Board.vue?vue&type=template&id=4aee9fc5&scoped=true"
import script from "./Board.vue?vue&type=script&lang=js"
export * from "./Board.vue?vue&type=script&lang=js"

import "./Board.vue?vue&type=style&index=0&id=4aee9fc5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alex3\\WD\\five-in-a-row\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aee9fc5"]])

export default __exports__